import { ADDRESS_STATE_OPTIONS } from "~/constants/all";
import type { Address, State } from "~/types/collections";
import { trimIfString } from "~/util/cleanData";

export const getStateNameFromValue = (state: string): string => {
  if (!state) return "";

  const stateOption = ADDRESS_STATE_OPTIONS.find(
    (option) => option.value.toUpperCase() === state.toUpperCase()
  );

  return stateOption ? stateOption.label : "";
};

const checkState = (
  state?: State | null | undefined
): State | null | undefined => {
  if (!state) return undefined;

  const stateOption = ADDRESS_STATE_OPTIONS.find(
    (option) => option.value === state
  );

  return stateOption ? state : null;
};

export const cleanAddress = (address: Address): Address => {
  return {
    line1: trimIfString(address?.line1),
    line2: trimIfString(address?.line2),
    city: trimIfString(address?.city),
    state: checkState(address?.state),
    postalCode: trimIfString(address?.postalCode),
  };
};
